import urlParser from './urlParser';

const currentLanguage = urlParser.language;

/**
 * booking link
 */
const bookingBranchID = {
	xinzhuang: 'chateaudechinexinzhuan',
	kaohsiung: 'chateaudechinehotelkaohsiung',
	hualien: 'ChateaudeChineHotelHualien',
}[urlParser.branch];
const bookingLink = `//book-directonline.com/properties/${bookingBranchID}`;

/**
 * booking Language
 */
const bookingLanguageID = {
	tw: 'zh-TW',
	en: 'en&promocode=taiwan',
	jp: 'ja',
	cn: 'zh-CN',
	kr: 'ko',
}[currentLanguage];

const hualienBookingLanguageID = {
	tw: 'zh-TW',
	en: 'en&promocode=TAIWAN',
	jp: 'ja&promocode=TAIWAN',
	cn: 'zh-CN',
	kr: 'ko&promocode=TAIWAN',
}[currentLanguage];

const setBookingLink = ($booking) => {
	/**
	 * set Language
	 */
	switch (urlParser.branch) {
	case 'kaohsiung':
	case 'xinzhuang':
		$booking.attr('href', `${bookingLink}direct?locale=${bookingLanguageID}`);
		break;
	case 'hualien':
		$booking.attr('href', `${bookingLink}DIRECT?locale=${hualienBookingLanguageID}`);
		break;
	default:
		break;
	}
};

export default setBookingLink;



// WEBPACK FOOTER //
// ./src/js/setBookingLink.js